import fpFetch from "../../../services/fpFetch";
import { BASE_API_URL } from "../../../constants";
import { handleError } from "../../../utils/handleError";

const deleteWorkspaceById = async (workspaceId) => {
  try {
    await fpFetch(`${BASE_API_URL}/workspaces/delete`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        _id: workspaceId,
      }),
    });
  } catch (error) {
    handleError({
      error,
      location: "deleteWorkspaceById",
    });
  }
};

export { deleteWorkspaceById };
